<!-- mutiple adr line -->
<div>
    <br>
    <br>
</div>
<div>
    <h4 class="primColor">{{'DANGEROUSGOODS' | translate}}</h4>
    <div class="adr_propper_grid">
        <div style="display: flex; flex-direction: column; gap: 5px;">
            <div>
                <div class="flex align-items-center gap-2" *ngIf="!adrConsent && GetADRFormControls.length == 0">
                    <p-checkbox (onChange)="AdrAcerptToggle($event)" inputId="adrConsent"></p-checkbox>
                    <label for="adrConsent">
                        *Ved at acceptere indvilliger du i at tage ansvar for, at point og information ang. ADR er
                        korrekte og lovlige i forhold til ADR-bogen.
                    </label>
                </div>

            </div>
            <div style="display: flex; flex-direction: row; gap: 12px; justify-content: space-between;" *ngIf="adrConsent">
                <button pButton (click)="AddADRLine()">{{'DANGEROUSGOODSTABLEHEADER.ADDADR' | translate}}</button>
                <p-toggleButton class="fakePadding" [disabled]="!(GetADRFormControls != null && GetADRFormControls.length > 0 )" [formControl]="UseAutoPointFunctionControll" [checked]="UseAutoPointFunction"
                                [onLabel]="'Fjern ADR-point'" [offLabel]="'DANGEROUSGOODSTABLEHEADER.OFFADRAUTO' | translate"
                                [onIcon]="'pi pi-lock'"
                                offIcon="pi pi-lock-open" (onChange)="UseAutoCalclulateFunction($event.checked)"></p-toggleButton>
            </div>
            <p *ngIf="UseAutoPointFunction" style="font-style: italic;">* {{'DANGEROUSGOODSTABLEHEADER.ADRDISCLAMED' | translate}}.</p>
        </div>




        <p-table #adrTable [value]="GetADRFormControls.controls" dataKey="RowId">
            <ng-template pTemplate="header">
                <tr>
                    <th>{{'DANGEROUSGOODSTABLEHEADER.TEXT' | translate}}</th>
                    <th>{{'DANGEROUSGOODSTABLEHEADER.CODE' | translate}}</th>
                    <!-- <th>{{'DANGEROUSGOODSTABLEHEADER.LIQUIDVOLUME' | translate}}</th> -->
                    <th>{{'DANGEROUSGOODSTABLEHEADER.SOILDVOLUME' | translate}}</th>
                    <th>{{'DANGEROUSGOODSTABLEHEADER.POINTS' | translate}}</th>
                    <th>{{'LQ (Low Qurntry)'}}</th>
                    <th style="width:8rem"></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-line let-editing="editing" let-ri="RowId">
                <tr [formGroup]="line" [pEditableRow]="line">
                    <td pEditableColumn>
                        <p-cellEditor>
                            <p class="pi pi-info" pTooltip="samlet volume skal være over 0 (Kilo + Liter)" style="color:var(--primary-color)" *ngIf="line.hasError('volumeInvalid')"> </p>
                            <ng-template pTemplate="input" required>
                                <p-autoComplete #autoCompleteObject autofocus formControlName="SelectedAdr" (onSelect)="SetAdrCodeOnForm($event.value,line)" [suggestions]="foundAdrs" [minLength]="2"
                                                inputId="adr" [field]="'waybillString'" (completeMethod)="adrSearch($event)" [showEmptyMessage]="true" emptyMessage="{{'NOADRFOUND' | translate}}" [baseZIndex]="1500" appendTo="body">
                                    <ng-template let-adr pTemplate="adr">
                                        <div class="adr-item">
                                            <span>{{adr.waybillString}}</span>
                                        </div>
                                    </ng-template>
                                </p-autoComplete>
                            </ng-template>
                            <ng-template pTemplate="output">
                                <div class="custom-input"> {{line.controls.SelectedAdr.value?.waybillString ?? "tryk for at vælge"}} </div>
                            </ng-template>

                        </p-cellEditor>
                    </td>
                    <td>
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <input pInputText type="text" formControlName="AdrCode">
                            </ng-template>
                            <ng-template pTemplate="output">{{line.controls.SelectedAdr.value?.unNumber}}</ng-template>
                        </p-cellEditor>
                    </td>
                    <!-- TODO: when old ob supports liqune values then use this line -->
                    <!-- <td pEditableColumn>
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <input pInputText formControlName="ADRLiquneVolume" type="number">
                        </ng-template>
                        <ng-template pTemplate="output">
                            <div style="display: flex; flex-direction: column;">
                                {{line.controls.ADRLiquneVolume.value ?? 0}}
                            </div>
                        </ng-template>

                    </p-cellEditor>
                </td> -->

                    <td pEditableColumn>
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <input pInputText formControlName="ADRSoildVolume" (change)="CalcluLateAdrPoint(line)"
                                       type="number">
                            </ng-template>
                            <ng-template pTemplate="output">
                                <div class="custom-input">
                                    {{line.controls.ADRSoildVolume.value ?? 0}}
                                </div>
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <td pEditableColumn>
                        <span class="pi pi-exclamation-triangle"
                              [pTooltip]="getTranslationNameFromReason(line.controls.rejectReson.value,line.controls.SelectedAdr.value?.unNumber) | translate"
                              style="color:var(--primary-color); padding-right: 5px;"
                              *ngIf="!line.controls.isAllowed.value"> </span>
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <input pInputText formControlName="points" type="number">
                            </ng-template>
                            <ng-template pTemplate="output">
                                <div class="custom-input">
                                    {{line.controls.points.value}}
                                </div>
                            </ng-template>
                        </p-cellEditor>
                    </td>
                    <!-- pEditableColumn -->
                    <td>
                        <span *ngIf="!line.controls.lowQuantity.value"> </span>
                        <p-inputSwitch formControlName="lowQuantity"></p-inputSwitch>
                        <!-- <p-cellEditor>
                            <ng-template pTemplate="input">
                                <p-inputSwitch formControlName="lowQuantity"></p-inputSwitch>
                            </ng-template>
                            <ng-template pTemplate="output">
                                <div *ngIf="line.controls.lowQuantity.value == true; else noneLQ">

                                    <i class="pi pi-check" pTooltip="This is marked as LQ shice means that eveything is packed into smaller container below the current rule set regarding adr"></i>
                                </div>
                                <ng-template #noneLQ>
                                    <i class="pi pi-times"></i>
                                </ng-template>
                            </ng-template>
                        </p-cellEditor> -->
                    </td>

                    <td style="text-align:center">
                        <button pButton pRipple type="button" icon="pi pi-trash" (click)="onRowEditCancel(line)"
                                class="p-button-rounded p-button-danger"></button>
                    </td>

                </tr>

            </ng-template>
            <ng-template pTemplate="footer">
                <tr>
                    <td>totaler:</td>
                    <td colspan="1"></td>
                    <!-- <td>{{GetLiquneTotalSum()}} liter</td> -->
                    <td>{{GetSolidTotalSum()}} kilo</td>
                    <td>
                        <div>
                            <span class="pi pi-exclamation-triangle"
                                  [pTooltip]="'DANGEROUSGOODSTABLEHEADER.ADROVERLIMIT' | translate"
                                  style="color:var(--primary-color); padding-right: 5px;"
                                  *ngIf="GetPointTotalSum() > 1000"> </span>
                            {{GetPointTotalSum() == 0 ? '' : GetPointTotalSum()}} points
                        </div>
                    </td>
                    <td colspan="1"></td>
                    <!-- <td colspan="1"></td> -->
                </tr>
            </ng-template>
        </p-table>

        <!-- <p-divider></p-divider> -->
        <hr>
        <div class="bottomBar" *ngIf="!isModal; else EditModalADR;">
            <button pButton pRipple label="{{'GENERIC.PREVIOUS' | translate}}" *ngIf="stepperService.activeIndex > 0"
                    (click)="stepperService.stepPrev()"></button>
            <button pButton pRipple label="{{'GENERIC.NEXT' | translate}}" [disabled]="!ADRFormGroup.valid"
                    [pTooltip]="ADRFormGroup.valid ? 'gå til næste step' : 'samlet volume per linje skal være over nul'"
                    (click)="CheckADrOnShipment();"></button>
        </div>
        <ng-template #EditModalADR>
            <div style="display: flex; flex-direction: row; justify-content: flex-end; gap: 8px; align-items: stretch;">
                <button pButton pRipple [label]="'GENERIC.SAVE' | translate " (click)="OutputModal()"></button>
                <button pButton pRipple [label]="'primeng.aria.cancelEdit' | translate" (click)="closeModal()"></button>
            </div>
        </ng-template>
    </div>